<template>
  <div>
    <v-container :class="ui.bkgdColor">
      <div class="mt-2"/>
      <v-layout row class="ml-3 mt-3 mr-3">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
          Review Progress
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
            <v-icon>
              {{this.trans.flow[this.trans.flow.length - 1].icon}}
            </v-icon>
          </v-avatar>
          {{this.trans.flow[this.trans.flow.length - 1].title}}
        </v-chip>
        <div class="hidden-sm-and-down">
          <TransitionsStats/>
        </div>
      </v-layout>
      <v-layout class="ml-4 mr-4">
        <v-progress-linear
          height="3"
          :background-color="ui.colorBlue"
          :color="ui.colorSuccess"
          :value="calcTransionsProgressBar()"
        ></v-progress-linear>
      </v-layout>
      <v-layout row class="ml-3 mt-3 mr-3">
        <v-flex xs11 offset-xs1>
          <v-layout row class="mr-2">
            <v-flex xs4>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon>create</v-icon>
                </v-avatar>
                Initial
              </v-chip>
            </v-flex>
            <v-flex xs4>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
              class="hidden-md-and-down">
                <v-avatar>
                <v-icon>today</v-icon>
                </v-avatar>
                {{dateTypeA(this.trans.flow[this.trans.flow.length - 1].date)}}
              </v-chip>
            </v-flex>
            <v-flex xs4>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                  <v-icon>
                    {{this.trans.flow[0].icon}}
                  </v-icon>
                </v-avatar>
                {{this.trans.flow[0].title}}
              </v-chip>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row class="ml-3 mr-3"
      v-if="this.trans.flow.length > 2">
        <v-flex xs11 offset-xs1>
          <v-layout row class="mr-2">
            <v-flex xs4>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon>history</v-icon>
                </v-avatar>
                Prior
              </v-chip>
            </v-flex>
            <v-flex xs4>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
              class="hidden-sm-and-down">
                <v-avatar>
                <v-icon>today</v-icon>
                </v-avatar>
                {{dateTypeA(this.trans.flow[this.trans.flow.length - 2].date)}}
              </v-chip>
            </v-flex>
            <v-flex xs4>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                  <v-icon>
                    {{this.trans.flow[this.trans.flow.length - 2].icon}}
                  </v-icon>
                </v-avatar>
                {{this.trans.flow[this.trans.flow.length - 2].title}}
              </v-chip>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <div v-if="this.checkRequestOrgSame === false">
        <v-layout row class="ml-4 mt-3 mr-3">
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
            {{ accessInfoObj.title1 }}
          </v-chip>
          <v-spacer/>
        </v-layout>
        <v-layout row class="ml-4 mr-3">
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
            {{ accessInfoObj.title2 }}
          </v-chip>
          <v-spacer/>
        </v-layout>
      </div>
      <!-- <div v-if="
      this.checkRequestOrgSame === false &&
      this.tras.level < 2
      ">
        <v-layout row class="mb-2 ml-1" :class="ui.textDescription">
          <v-flex xs10 offset-xs1>
            {{defineTransInfo(this.trans.level - 1, this.trans.model).comn}}
          </v-flex>
        </v-layout>
      </div> -->
      <v-layout row class="mr-4">
        <v-spacer/>
        <v-layout row justify-end class="mt-1 mr-4 mb-4">
          <TransitionsList :data="{type: 'flow'}"/>
          <div class="mr-4"/>
          <TransitionsList :data="{type: 'history'}"/>
        </v-layout>
      </v-layout>
      <div v-if="revertEnabled || approvalEnabled">
        <v-layout row class="ml-4"
        v-if="
        (this.tag === 'G1' && this.trans.level !== 0) ||
        (this.tag === 'G1' && this.trans.level < 2)">
          <v-flex xs10 offset-xs1>
            <v-textarea
             v-model="transitionComments"
             :disabled="false"
             :outline="true"
             :rules="ruleMustBeNotUndefinedANDLessThan1000"
             hint="type approval or cancellation comments to unlock approve / cancel buttons"
             auto-grow
             persistent-hint
             ></v-textarea>
          </v-flex>
        </v-layout>
      </div>
      <!-- <div
      v-if="
      this.trans.flow[this.trans.flow.length - 1].title !== 'Complete' &&
      this.trans.level < 2
      ">
        <v-layout row class="ml-3 mr-3"
        v-if="this.trans.flow.length < this.defineTransSize(this.trans.model)">
          <v-flex xs10 offset-xs2>
            <v-layout row class="mr-1">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon>update</v-icon>
                </v-avatar>
                Next - {{defineTransInfo(this.trans.flow.length, this.trans.model).title}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
              v-if="this.getTransitions.stat.hold === true">
                <v-avatar>
                <v-icon left>info_outline</v-icon>
                Info
                </v-avatar>
              </v-chip>
            </v-layout>
          </v-flex>
        </v-layout>
      </div> -->
      <div>
        <AccessDetailAuthDescribe/>
      </div>
      <v-layout wrap row align-center justify-centre fill-height class="mt-4 mr-4">
        <v-spacer/>
        <v-btn
         :color="ui.colorError"
         outline
         :disabled="this.transitionComments === ''"
         v-if="this.auth === null && this.checkRequestOrgSame === false"
        >
          <v-icon left> warning </v-icon>
            Select Auth Level
        </v-btn>
        <v-btn
         @click="progressAccessTranistion(false)"
         :color="ui.colorError"
         outline
         :disabled="this.transitionComments === ''"
         v-if="rejectEnabled"
        >
          <v-icon left> no_accounts </v-icon>
            reject
        </v-btn>
        <v-btn
         @click="progressAccessTranistion(true)"
         :color="approvalBtn.color"
         outline
         :disabled="this.transitionComments === ''"
         v-if="approvalEnabled"
        >
          <v-icon left> {{approvalBtn.icon}} </v-icon>
            {{approvalBtn.title}}
        </v-btn>
      </v-layout>
      <v-layout wrap row align-center justify-centre fill-height class="mt-2 mr-4">
        <v-spacer/>
        <div v-if="lockBtnEnabled">
          <div v-if="btnSpinUserAccessLock === false">
            <v-btn
             @click="lockUserAccess(!localForm.lock)"
             :color="lockBtn.color" outline>
              <v-icon left>  {{lockBtn.icon}}  </v-icon>
                {{lockBtn.title}}
            </v-btn>
          </div>
          <div v-else>
            <BtnSpin :btnSpec="btnInfo1"/>
          </div>
        </div>
        <!-- <v-btn
         @click="holdTransition(!trans.stat.hold, transitionComments)"
         :color="holdBtn.color"
         outline
         :disabled="this.transitionComments === ''"
         v-if="holdBtnEnabled"
        >
          <v-icon left> {{holdBtn.icon}} </v-icon>
            {{holdBtn.title}}
        </v-btn> -->
      </v-layout>
    </v-container>
  </div>
</template>
<script>
// eslint-disable-next-line
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import TransitionsList from "@/support/transitions/components/TransitionsList";
import TransitionsStats from "./TransitionsStats";
import AccessDetailAuthDescribe from "@/support/access/components/AccessDetailAuthDescribe";
import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import changeFirebase from "@/data/cloud/firebase/mixins/changeFirebase.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
export default {
  components: {
    // eslint-disable-next-line
    AccessDetailAuthDescribe,
    TransitionsStats,
    TransitionsList,
    BtnSpin
  },
  // eslint-disable-next-line
  mixins: [
    rulesTextfield,
    dateFunctions,
    apptheme,
    transFunctions,
    changeFirebase
  ],
  updated() {
    this.localForm.lock = this.getDetailBasic.lock;
  },
  beforeMount() {
    this.localForm.lock = this.getDetailBasic.lock;
    this.orgForm.cauth = this.getDetailSelect.cauth;
  },
  // eslint-disable-next-line
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getTransitions",
      "getCurrentPage",
      "getDetail",
      "getDetailChar",
      "getDetailSelect",
      "getDetailBasic",
      "getUser"
    ]),
    trans() {
      return this.getTransitions;
    },
    tag() {
      return this.getDetail.basic.tag;
    },
    tagd() {
      return this.getDetail.basic.tagd;
    },
    checkRequestOrgSame() {
      // check if you are access orginator and if yes
      // then disable some functions
      let logic = null;
      // your user id
      let udid = this.getUser.basic.did;
      // request user id
      let rdid = this.getDetail.char.udid;
      // check for
      if (udid == rdid) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    auth() {
      let auth = null;
      if (this.getDetailSelect !== null) {
        if (this.getDetailSelect.cauth !== null) {
          auth = this.getDetailSelect.cauth;
        } else if (this.getDetailSelect.fauth !== null) {
          auth = this.getDetailSelect.fauth;
        } else {
          auth = null;
        }
      } else {
        auth = null;
      }
      return auth;
    },
    accessInfoObj() {
      let obj = {
        title1: "",
        title2: ""
      };
      if (this.getDetailChar.tag === "F1") {
        obj.title1 = "Facility Access Review";
      } else {
        obj.title1 = "Company Access Review";
      }
      obj.title2 = this.getDetailChar.title;
      return obj;
    },
    approverVerify() {
      let verify = false;
      if (
        this.getDetailSelect.cdid !== "" &&
        this.getDetailSelect.cidg !== ""
      ) {
        let did = this.getDetailSelect.cdid;
        if (
          did === this.getUser.pref.select.cdid &&
          this.getUser.pref.select.cauth < 2
        ) {
          verify = true;
        } else if (this.getUser.basic.admin === true) {
          verify = true;
        } else {
          verify = false;
        }
      } else {
        // same check but for facility
        let did = this.getDetailSelect.fdid;
        if (
          did === this.getUser.pref.select.fdid &&
          this.getUser.pref.select.fauth < 2
        ) {
          verify = true;
        } else if (this.getDetailSelect.fauth === 0) {
          verify = true;
        } else {
          verify = false;
        }
      }
      return verify;
    },
    // approvalEnabled() {
    //   if (
    //     this.trans.level === 1 &&
    //     this.approverVerify === true &&
    //     this.auth !== null &&
    //     this.btnPressed === false
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    approvalEnabled() {
      if (
        this.approverVerify === true &&
        this.auth !== null &&
        this.btnPressed === false
      ) {
        return true;
      } else {
        return false;
      }
    },
    rejectEnabled() {
      let logic = false;
      if (
        this.getDetailSelect.cauth !== null &&
        this.getDetailSelect.cauth !== undefined &&
        this.getDetailSelect.fauth !== null &&
        this.getDetailSelect.fauth !== undefined &&
        this.getDetailSelect.fauth === 0
      ) {
        logic = false;
      } else if (
        this.trans.level === 1 &&
        this.approverVerify === true &&
        this.btnPressed === false &&
        this.auth !== null
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    revertEnabled() {
      // eslint-disable-next-line
      if (
        this.tag === "G1" &&
        this.trans.level < 2 &&
        this.trans.stat.hold === true
      ) {
        return true;
      } else if (
        this.trans.level === 1 &&
        (this.tag === "G1" && this.trans.level < 2) &&
        this.trans.stat.cancel === false &&
        this.trans.stat.hold === false
      ) {
        return true;
      } else {
        return false;
      }
    },
    holdBtnEnabled() {
      if (this.trans.level === 1 && this.btnPressed === false) {
        return true;
      } else {
        return false;
      }
    },
    lockBtnEnabled() {
      if (
        this.getDetail.trans.level > 1 &&
        this.getUser.pref.select.cauth !== null &&
        this.getUser.pref.select.cauth !== undefined &&
        this.getUser.pref.select.cauth < 2
      ) {
        return true;
      } else {
        return false;
      }
    },
    lockBtnORG() {
      let obj = {
        icon: "",
        title: "",
        color: ""
      };
      if (this.tag === "G1" && this.trans.stat.lock === false) {
        obj.title = "lock";
        obj.icon = "lock";
        obj.color = this.ui.colorWarning;
      } else if (this.tag === "G1" && this.trans.stat.lock === true) {
        obj.title = "unlock";
        obj.icon = "lock_open";
        obj.color = this.ui.colorWarning;
      } else {
        obj.title = "approve";
        obj.icon = "done";
        obj.color = this.ui.colorSuccess;
      }
      return obj;
    },
    lockBtn() {
      let obj = {
        icon: "",
        title: "",
        color: ""
      };
      if (this.tag === "G1" && this.getDetailBasic.lock === false) {
        obj.title = "lock";
        obj.icon = "lock";
        obj.color = this.ui.colorWarning;
      } else if (this.tag === "G1" && this.getDetailBasic.lock === true) {
        obj.title = "unlock";
        obj.icon = "lock_open";
        obj.color = this.ui.colorSuccess;
      } else {
        obj.title = "approve";
        obj.icon = "done";
        obj.color = this.ui.colorSuccess;
      }
      return obj;
    },
    holdBtn() {
      let obj = {
        icon: "",
        title: "",
        color: ""
      };
      if (this.tag === "G1" && this.trans.stat.hold === false) {
        obj.title = "add info";
        obj.icon = "add";
        obj.color = this.ui.colorWarning;
      } else if (this.tag === "G1" && this.trans.stat.hold === true) {
        obj.title = "add info";
        obj.icon = "add";
        obj.color = this.ui.colorWarning;
      } else {
        obj.title = "uncertain";
        obj.icon = "done";
        obj.color = this.ui.colorWarning;
      }
      return obj;
    },
    approvalBtn() {
      let obj = {
        icon: "",
        title: "",
        color: ""
      };
      if (this.tag === "G1") {
        obj.title = "agree";
        obj.icon = "person";
        obj.color = this.ui.colorSuccess;
      } else {
        obj.title = "approve";
        obj.icon = "done";
        obj.color = this.ui.colorSuccess;
      }
      return obj;
    },
    revertBtn() {
      let obj = {
        icon: "",
        title: "",
        color: ""
      };
      if (this.tag === "G1") {
        obj.title = "submit info";
        obj.icon = "add";
        obj.color = this.ui.colorWarning;
      } else {
        obj.title = "restart_alt";
        obj.icon = "revert";
        obj.color = this.ui.colorSuccess;
      }
      return obj;
    },
    cancelEnabled() {
      let k = this.trans.steps - 1;
      if (
        this.trans.level > 1 &&
        this.tag === "A1" &&
        this.trans.cancel === false &&
        this.trans.level < k
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  props: {
    listIndex: {
      type: Number
    }
  },
  methods: {
    progressAccessTranistion(logic) {
      this.btnPressed = true;
      this.progressTranistion(logic, this.trans.level, this.transitionComments);
    },
    changeUnsavedStatusIndication() {
      if (this.getCurrentPage === "/procedureview") {
        this.$store.dispatch("changeUnsavedProcedureIndication", true);
      }
      if (this.getCurrentPage === "/maintplanedit") {
        this.$store.dispatch("changeUnsavedMaintPlanIndication", true);
      }
    },
    lockUserAccess(status) {
      console.log("HU");
      this.btnSpinUserAccessLock = true;
      const userDID = this.getDetailChar.udid;
      // eslint-disable-next-line
      this.changeUserAccessLockStatus(userDID, status);
      // let status = lockStatus;
      // GET USER UNDER ACCESS - REMOTE STATS (USER STATS)
      // THEN CHANGE AS PER THE STATUS
      // THEN UPDATE COMPANY ACCESS with new Parameter (use basic lock)
      // Save access autrise automatically
      // change admin
      // this.$store.dispatch("changeDataSavePendingIndication", true);
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      btnPressed: false,
      enableSpinner: false,
      btnSpinUserAccessLock: false,
      iconInfoForNextStep: "contact_support",
      transitionComments: "",
      localForm: {
        com: "",
        lock: false,
        cauth: 10,
        fauth: 10
      },
      orgForm: {
        cauth: 10,
        fauth: 10,
        com: "",
        lock: false
      },
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "flat"
      }
    };
  }
};
</script>
